/**
 * Intraday tick tape: buy-aggressor (B) vs sell-aggressor (A) share totals.
 * Values come from `/intraday-trades` summary (same session window as analytics).
 */

export interface IntradayTapeBuySellTotals {
  buyShares: number;
  sellShares: number;
  neutralShares: number;
}

/**
 * Returns rounded share counts from analytics summary, or null when there is no tape volume.
 */
export function intradayTapeBuySellFromSummary(
  summary: {
    buy_volume?: number | null;
    sell_volume?: number | null;
    neutral_volume?: number | null;
  } | null | undefined,
): IntradayTapeBuySellTotals | null {
  if (!summary) return null;
  const buyShares = Math.max(0, Math.round(Number(summary.buy_volume ?? 0)));
  const sellShares = Math.max(0, Math.round(Number(summary.sell_volume ?? 0)));
  const neutralShares = Math.max(0, Math.round(Number(summary.neutral_volume ?? 0)));
  const total = buyShares + sellShares + neutralShares;
  if (total <= 0) return null;
  return { buyShares, sellShares, neutralShares };
}
